/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2022-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React from 'react';
import Helmet from "react-helmet";
import './serviceUnavailable.scss';
import {Col, Row} from 'react-bootstrap';
import Footer from "../../components/app-common/Footer";

const ServiceUnavailable = () => (
        <div className="service-unavailable-container">
            <Helmet defer={false} title="Service Unavailable"/>
            <div className="service-unavailable-inner-container">
                <Row>
                    <Col sm={12}>
                        <Row className="heading">
                            <Col sm={12} className="text-center">
                                <h2>The Service Portal is temporarily unavailable</h2>
                                <h3>The application may still be initializing. Please try again later.</h3>
                            </Col>
                        </Row>


                    </Col>
                </Row>
            </div>
            <Footer hideVersion/>
        </div>
)

export default ServiceUnavailable;
